import { Sheet as BaseSheet, SheetContent, SheetFooter, SheetHeader, SheetTitle } from "../../ui/sheet";
import { cn } from "../../../lib/utils";
import type { SheetProps } from "./types";

function Sheet({ title, open, close, children, footer, side = "right", contentClassName, bodyClassName }: SheetProps) {
    return (
        <BaseSheet open={open} onOpenChange={close}>
            <SheetContent
                side={side}
                className={cn(
                    "tw-flex tw-flex-col tw-h-auto tw-top-2 tw-bottom-2 tw-w-full tw-p-0 tw-gap-0 tw-overflow-hidden sm:tw-max-w-4xl tw-rounded-lg tw-m-2 tw-p-3",
                    "[&>button]:tw-top-9 [&>button]:tw-right-6 [&>button]:tw-rounded-lg",
                    contentClassName
                )}
            >
                <SheetHeader className="tw-px-6 tw-py-4 tw-border-b tw-space-y-0">
                    <SheetTitle className="tw-text-lg">{title}</SheetTitle>
                </SheetHeader>

                <div className={cn("tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-px-6 tw-py-4", bodyClassName)}>
                    {children}
                </div>

                {footer && (
                    <SheetFooter className="tw-px-6 tw-py-4 tw-border-t tw-flex-row tw-space-x-2 sm:tw-space-x-2">
                        {footer}
                    </SheetFooter>
                )}
            </SheetContent>
        </BaseSheet>
    );
}

export default Sheet;
